import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';

export interface IAnimatedDivBone {
  className?: string;
}

const blockName = 'animated-div-bone';

export default function AnimatedDivBone({ className }: IAnimatedDivBone) {
  const bem = useBemCN(blockName);

  return <div {...bem(null, null, [useBemCN('frame-bone')().className, className])} />;
}
